import Header from "../layout/Header";
import Footer from "../layout/Footer";

const DashboardPublic = ({ children }) => (
  <div className="App flex flex-col min-h-screen">
    <Header />
    <main className="content flex-grow">{children}</main>
    <Footer />
  </div>
);

export default DashboardPublic;
